import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
  FormGroup,
  Input,
  Label,
  FormFeedback,
} from "reactstrap";
import Select from "react-select";
import {
  getPlans,
  getRouteSelects,
  resourcesRoutes,
  usersProfile,
} from "../../../helpers/backend_helper";
import { getStorageCompany } from "../../../helpers/api_helper";

import { useFormik } from "formik";
import * as Yup from "yup";
import classNames from "classnames";
import NibbleInput from "../../../components/Fields/NibbleInput";

const YESNO = [
  { label: "Si", value: true },
  { label: "No", value: false },
];

const AddUpdModal = ({
  modal,
  setModal,
  items,
  setItems,
  setItem,
  item,
  authUser,
}) => {
  const company = getStorageCompany();
  const [selects, setSelects] = useState({
    providers: [{ id: 0, name: "" }],
    groups: [{ id: 0, name: "" }],
    administrators: [
      { id: 0, name: "no selected" },
      { id: 1, name: "d selected" },
    ],
  });
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState([]);

  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { ...item },
    validationSchema: Yup.object({
      plan_id: Yup.string().nullable(true),
      name: Yup.string().nullable(true).required("Requerido"),
      active: Yup.bool().nullable(true).required("Requerido"),
      nameAdmin: item.newAdministrator
        ? Yup.string().required("Nombre de concesionario requerido")
        : Yup.string(),
      email: item.newAdministrator
        ? Yup.string().email("Debe ser un correo válido").required("Requerido")
        : Yup.string(),
      password: item.newAdministrator
        ? Yup.string()
            .min(6, "La contraseña debe tener al menos 6 caracteres")
            .required("Contraseña requerida")
        : Yup.string(),
      password_confirm: item.newAdministrator
        ? Yup.string()
            .oneOf([Yup.ref("password"), null], "Las contraseñas no coinciden")
            .required("Confirmación de contraseña requerida")
        : Yup.string(),
      phone: Yup.string()
        .nullable(true)
        .matches(/\b\d{10}\b/, "Debe contener 10 dígitos"),
      slug: Yup.string()
        .nullable(true)
        .required("Requerido")
        .matches(
          /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
          "El campo solo debe contener letras/números o guiones"
        ),
    }),
    onSubmit: async (values) => {
      await save(values);
    },
  });

  useEffect(() => {
    if (authUser.can.routes.all) {
      usersProfile(3, company.id).then((response) => {
        setSelects({ ...selects, administrators: response.administrators });
      });
    }
  }, []);

  useEffect(() => {
    getPlans().then((response) => {
      setPlans(response.plans.data);
    });
  }, []);

  const save = async (data) => {
    try {
      setLoading(true);
      const response = modal.update
        ? await resourcesRoutes("put", data, data.id)
        : await resourcesRoutes("post", data);
      responseAction(response);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const responseAction = (response) => {
    if (response.status) {
      const newItem = response.route;
      let array = [];
      if (modal.update) {
        array = items.map((item) => (item.id !== newItem.id ? item : newItem));
      } else {
        array = [...items, newItem];
        array.sort((a, b) => {
          return a.id - b.id;
        });
      }
      setItems(array);
      handleClose();
      setLoading(false);
    } else {
      setLoading(false);
      setErrors(response.response.data.errors);
    }
  };

  const getSelects = (id = 0) => {
    getRouteSelects(id).then((response) => {
      if (id) {
        setSelects({ ...selects, groups: response.groups });
      } else {
        if (authUser.can.routes.all) {
          usersProfile(3, company.id).then((resp) => {
            setSelects({
              ...selects,
              administrators: resp.administrators,
              providers: response.providers,
            });
          });
        } else {
          setSelects({ ...selects, providers: response.providers });
        }
      }
    });
  };

  useEffect(() => {
    getSelects();
  }, []);

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-primary">
          {modal.update ? "Editar " : "Nueva "}Ruta
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              <div className="col-sm-6">
                <label className="form-label">Nombre:</label>
                <Input
                  className="form-control"
                  name="name"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.name}
                  invalid={validation.touched.name && validation.errors.name}
                />
                <FormFeedback type="invalid">
                  {validation.errors.name}
                </FormFeedback>
              </div>
              <div className="col-sm-6">
                <label className="form-label">Activa:</label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={false}
                  defaultValue={item.active}
                  name="active"
                  value={
                    YESNO.filter(
                      (e) => e.value == validation.values.active
                    )[0] ?? null
                  }
                  options={YESNO}
                  onChange={(option, meta) => {
                    validation.setFieldValue("active", option.value, true);
                  }}
                />
                <FormFeedback type="invalid">
                  {validation.errors.active}
                </FormFeedback>
              </div>
              <div className="col-sm-6 mt-2">
                <label className="form-label">Proveedor externo:</label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  defaultValue={item.provider}
                  isSearchable={true}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option.id}`}
                  name="provider_id"
                  value={
                    selects.providers.filter(
                      (e) => e.id == validation.values.provider_id
                    )[0] ?? null
                  }
                  options={selects.providers}
                  onChange={(option, meta) => {
                    validation.setFieldValue("provider_id", option.id, true);
                  }}
                />
                <FormFeedback type="invalid">
                  {validation.errors.provider_id}
                </FormFeedback>
              </div>
              <div className="col-sm-6 mt-2">
                <label className="form-label">ID Ruta Externo:</label>
                <Input
                  className="form-control"
                  name="external_id"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.external_id}
                  invalid={
                    validation.touched.external_id &&
                    validation.errors.external_id
                  }
                />
                <FormFeedback type="invalid">
                  {validation.errors.external_id}
                </FormFeedback>
              </div>
              <div className="col-sm-6 mt-2">
                <label className="form-label">Slug:</label>
                <Input
                  className="form-control"
                  name="slug"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.slug}
                  invalid={validation.touched.slug && validation.errors.slug}
                />
                <FormFeedback type="invalid">
                  {validation.errors.slug}
                </FormFeedback>
              </div>

              {authUser.profile_id == 2 ? (
                <NibbleInput
                  md={6}
                  label="Plan:"
                  fieldName="plan_id"
                  fieldType="select"
                  selectItems={plans}
                  validation={validation}
                />
              ) : null}

              {validation.values.newAdministrator && (
                <div className="col-sm-12 mt-3">
                  <h5>Administrador</h5>
                </div>
              )}

              {false && !validation.values.id && (
                <>
                  <div className="col-sm-12">
                    <FormGroup check inline={true}>
                      <Input
                        id="admin_new"
                        name="administratorNew"
                        type="radio"
                        onChange={(e) => [
                          setItem({ ...item, administratorNew: true }),
                          setNewAdministrator(true),
                        ]}
                        checked={validation.values.newAdministrator}
                      />
                      <Label for="admin_new" check>
                        Nuevo Administrador
                      </Label>
                    </FormGroup>
                    <FormGroup check inline={true}>
                      <Input
                        id="admin_exist"
                        name="administratorNew"
                        type="radio"
                        onChange={(e) => [
                          setItem({ ...item, administratorNew: false }),
                          setNewAdministrator(false),
                        ]}
                        checked={!validation.values.newAdministrator}
                      />
                      <Label for="admin_exist" check>
                        Seleccionar Administrador
                      </Label>
                    </FormGroup>
                  </div>
                  <hr className="mt-3" />
                </>
              )}

              {false &&
                authUser.profile_id != 4 &&
                !validation.values.newAdministrator && (
                  <div className="col-sm-6">
                    <label className="form-label">Administrador:</label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable={true}
                      isSearchable={true}
                      getOptionLabel={(option) => `${option.name}`}
                      getOptionValue={(option) => `${option.id}`}
                      name="administrator_id"
                      value={
                        selects.administrators.filter(
                          (e) => e.id == validation.values.administrator_id
                        )[0] ?? null
                      }
                      options={selects.administrators}
                      onChange={(option, meta) => {
                        validation.setFieldValue(
                          "administrator_id",
                          option.id,
                          true
                        );
                      }}
                    />
                    <FormFeedback type="invalid">
                      {validation.errors.administrator_id}
                    </FormFeedback>
                  </div>
                )}
              {validation.values.newAdministrator && (
                <>
                  <div className="col-sm-6">
                    <label className="form-label">Nombre:</label>
                    <Input
                      className="form-control"
                      name="nameAdmin"
                      type="text"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.nameAdmin}
                      invalid={
                        validation.touched.nameAdmin &&
                        validation.errors.nameAdmin
                      }
                    />
                    <FormFeedback type="invalid">
                      {validation.errors.nameAdmin}
                    </FormFeedback>
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">Email:</label>
                    <Input
                      className="form-control"
                      name="email"
                      type="text"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email}
                      invalid={
                        validation.touched.email && validation.errors.email
                      }
                    />
                    <FormFeedback type="invalid">
                      {validation.errors.email}
                    </FormFeedback>
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">Teléfono Celular:</label>
                    <Input
                      className="form-control"
                      name="phone"
                      type="number"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.phone}
                      invalid={
                        validation.touched.phone && validation.errors.phone
                      }
                    />
                    <FormFeedback type="invalid">
                      {validation.errors.phone}
                    </FormFeedback>
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">Teléfono Local:</label>
                    <Input
                      className="form-control"
                      name="local_phone"
                      type="number"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.local_phone}
                      invalid={
                        validation.touched.local_phone &&
                        validation.errors.local_phone
                      }
                    />
                    <FormFeedback type="invalid">
                      {validation.errors.local_phone}
                    </FormFeedback>
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">Contraseña:</label>
                    <Input
                      className="form-control"
                      name="password"
                      type="password"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.password}
                      invalid={
                        validation.touched.password &&
                        validation.errors.password
                      }
                    />
                    <FormFeedback type="invalid">
                      {validation.errors.password}
                    </FormFeedback>
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">Repetir contraseña:</label>
                    <Input
                      className="form-control"
                      name="password_confirm"
                      type="password"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.password_confirm}
                      invalid={
                        validation.touched.password_confirm &&
                        validation.errors.password_confirm
                      }
                    />
                    <FormFeedback type="invalid">
                      {validation.errors.password_confirm}
                    </FormFeedback>
                  </div>
                </>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              {" "}
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
